import React, { Fragment } from "react";
import Header from "../shared/general/Header";
import CreateAccountForm from "./CreateAccountForm";
import Footer from "../shared/general/Footer";

const EmployerCreateAccount = () => (
  <Fragment>
    <Header />
    <CreateAccountForm />
    <Footer positionAbsolute />
  </Fragment>
);

export default EmployerCreateAccount;
